import type { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import type { CompositeScreenProps } from '@react-navigation/native';
import type { StackScreenProps } from '@react-navigation/stack';

import {
  CORE_DEEPLINK_CONFIG,
  CoreRootStackParamList,
  DeeplinkConfigShape,
  NavigatorScreenParams,
} from '@oui/app-core/src/types/navigation';
import {
  STRESS_BREATHING_DEEPLINK_CONFIG,
  StressBreathingStackParamList,
} from '@oui/stress-breathing';
import { WORD_PAIRING_DEEPLINK_CONFIG, WordPairingStackParamList } from '@oui/word-pairing';

export type RootStackParamList = {
  home: NavigatorScreenParams<HomeTabParamList>;
  Welcome: undefined;
  Confidentiality: undefined;
  CreateTestUser: undefined;
  GetStarted: undefined;
  MyProgress: undefined;
  StressSensitivityAssessment: { type: 'before' | 'after' };
} & CoreRootStackParamList &
  StressBreathingStackParamList &
  WordPairingStackParamList;

export type RootStackScreenProps<T extends keyof RootStackParamList> = StackScreenProps<
  RootStackParamList,
  T
>;

export type HomeTabParamList = {
  Home: undefined;
  Learn: undefined;
  Practice: undefined;
  UserProfile: undefined;
};

export type TabScreenProps<T extends keyof HomeTabParamList> = CompositeScreenProps<
  BottomTabScreenProps<HomeTabParamList, T>,
  RootStackScreenProps<keyof RootStackParamList>
>;

const homeConfig = {
  Home: 'home',
  Learn: 'learn',
  Practice: 'practice',
  UserProfile: 'profile',
} as const satisfies DeeplinkConfigShape<keyof HomeTabParamList>;

export const DEEPLINK_CONFIG = {
  home: { screens: homeConfig },
  Welcome: 'welcome',
  Confidentiality: 'confidentiality',
  CreateTestUser: 'create-test-user',
  GetStarted: 'get-started',
  MyProgress: 'progress',
  StressSensitivityAssessment: 'stress-assessment',
  ...CORE_DEEPLINK_CONFIG,
  ...STRESS_BREATHING_DEEPLINK_CONFIG,
  ...WORD_PAIRING_DEEPLINK_CONFIG,
} as const satisfies DeeplinkConfigShape<keyof RootStackParamList>;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace ReactNavigation {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface RootParamList extends RootStackParamList {}
  }
}
